const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTribunnewsNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225px",
    height: "225px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfe",
    d: "M -0.5,-0.5 C 74.5,-0.5 149.5,-0.5 224.5,-0.5C 224.5,74.5 224.5,149.5 224.5,224.5C 149.5,224.5 74.5,224.5 -0.5,224.5C -0.5,149.5 -0.5,74.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e6da4",
    d: "M 97.5,2.5 C 151.151,-0.106116 189.651,22.5606 213,70.5C 228.007,113.813 220.674,152.813 191,187.5C 153.611,222.428 111.111,230.261 63.5,211C 19.9484,186.729 -0.551642,149.563 2,99.5C 9.51106,55.2915 34.0111,24.7915 75.5,8C 82.8681,5.83193 90.2014,3.9986 97.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2d5d8",
    d: "M 98.5,38.5 C 86.7109,37.234 74.7109,37.234 62.5,38.5C 67.5005,36.4416 72.8338,35.4416 78.5,35.5C 85.4264,35.6957 92.0931,36.6957 98.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 173.5,59.5 C 168.752,61.3641 164.085,63.5308 159.5,66C 151.422,66.7492 143.422,67.9159 135.5,69.5C 134.17,106.331 134.17,142.998 135.5,179.5C 136.492,179.672 137.158,179.338 137.5,178.5C 149.093,174.544 158.76,167.877 166.5,158.5C 168.384,158.288 169.717,157.288 170.5,155.5C 171.48,158.086 171.813,160.753 171.5,163.5C 170.588,167.251 168.922,170.584 166.5,173.5C 165.761,173.369 165.094,173.536 164.5,174C 152.732,191.812 135.899,200.979 114,201.5C 106.128,200.802 98.2947,199.802 90.5,198.5C 82.0377,195.434 73.7044,192.1 65.5,188.5C 56.8897,183.319 50.0563,176.319 45,167.5C 44.5172,166.552 44.3505,165.552 44.5,164.5C 39.245,149.17 38.245,133.504 41.5,117.5C 44.1137,110.994 46.1137,104.328 47.5,97.5C 49.9927,91.0203 53.6593,85.3536 58.5,80.5C 60.5952,79.588 62.5952,78.4213 64.5,77C 67.007,73.7988 69.8403,70.9655 73,68.5C 74.1618,67.8132 75.3284,67.6466 76.5,68C 75.6634,69.0113 75.33,70.1779 75.5,71.5C 70.7789,78.2755 67.1122,85.6089 64.5,93.5C 63.8501,93.8039 63.1835,94.1373 62.5,94.5C 61.3591,97.0618 60.5257,99.7284 60,102.5C 59.3333,111.833 59.3333,121.167 60,130.5C 60.2355,132.119 61.0689,133.119 62.5,133.5C 65.1723,146.152 71.5056,156.486 81.5,164.5C 82.8333,164.5 84.1667,164.5 85.5,164.5C 88.3466,159.127 90.5133,153.46 92,147.5C 92.6667,119.167 92.6667,90.8333 92,62.5C 88.2154,59.7135 84.7154,60.0468 81.5,63.5C 80.5836,63.4573 79.9169,63.1239 79.5,62.5C 79.2089,61.3509 78.3756,60.6842 77,60.5C 69.7913,59.0697 62.6247,59.2363 55.5,61C 44.2942,65.3861 34.9608,72.2194 27.5,81.5C 26.3483,78.8938 26.1816,76.2272 27,73.5C 31.0307,59.8004 39.1974,49.3004 51.5,42C 54.8931,39.9243 58.5598,38.7576 62.5,38.5C 74.7109,37.234 86.7109,37.234 98.5,38.5C 101.518,38.7038 104.518,39.0371 107.5,39.5C 120.271,44.5631 133.604,48.0631 147.5,50C 150.167,50.1667 152.833,50.3333 155.5,50.5C 158.59,50.4783 161.257,49.8117 163.5,48.5C 169.949,47.3884 174.282,43.7217 176.5,37.5C 177.325,36.6143 178.325,36.281 179.5,36.5C 179.75,41.5805 179.25,46.5805 178,51.5C 177.246,54.6844 175.746,57.3511 173.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dadcde",
    d: "M 107.5,39.5 C 120.942,41.8882 134.275,44.7216 147.5,48C 152.823,48.4994 158.156,48.666 163.5,48.5C 161.257,49.8117 158.59,50.4783 155.5,50.5C 152.833,50.3333 150.167,50.1667 147.5,50C 133.604,48.0631 120.271,44.5631 107.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f6da3",
    d: "M 81.5,164.5 C 71.5056,156.486 65.1723,146.152 62.5,133.5C 60.618,119.991 61.2847,106.658 64.5,93.5C 67.1122,85.6089 70.7789,78.2755 75.5,71.5C 78.667,68.502 82.0003,65.6686 85.5,63C 87.1341,62.5065 88.8008,62.3398 90.5,62.5C 90.6666,90.8353 90.5,119.169 90,147.5C 88.7398,154.02 85.9065,159.687 81.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e7e7e8",
    d: "M 81.5,164.5 C 85.9065,159.687 88.7398,154.02 90,147.5C 90.5,119.169 90.6666,90.8353 90.5,62.5C 88.8008,62.3398 87.1341,62.5065 85.5,63C 82.0003,65.6686 78.667,68.502 75.5,71.5C 75.33,70.1779 75.6634,69.0113 76.5,68C 75.3284,67.6466 74.1618,67.8132 73,68.5C 69.8403,70.9655 67.007,73.7988 64.5,77C 62.5952,78.4213 60.5952,79.588 58.5,80.5C 64.2662,73.0676 71.2662,67.0676 79.5,62.5C 79.9169,63.1239 80.5836,63.4573 81.5,63.5C 84.7154,60.0468 88.2154,59.7135 92,62.5C 92.6667,90.8333 92.6667,119.167 92,147.5C 90.5133,153.46 88.3466,159.127 85.5,164.5C 84.1667,164.5 82.8333,164.5 81.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2c6ca3",
    d: "M 129.5,70.5 C 129.5,106.833 129.5,143.167 129.5,179.5C 123.833,179.5 118.167,179.5 112.5,179.5C 102.408,178.787 93.4079,175.287 85.5,169C 87.0414,167.629 88.3747,166.129 89.5,164.5C 98.4783,158.557 105.645,150.891 111,141.5C 111.49,140.207 111.657,138.873 111.5,137.5C 113.094,133.75 114.261,129.75 115,125.5C 115.5,106.17 115.667,86.8362 115.5,67.5C 120.391,68.0099 125.058,69.0099 129.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#98a7b6",
    d: "M 129.5,70.5 C 130.498,106.996 130.832,143.663 130.5,180.5C 124.31,180.823 118.31,180.49 112.5,179.5C 118.167,179.5 123.833,179.5 129.5,179.5C 129.5,143.167 129.5,106.833 129.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9dbdd",
    d: "M 130.5,180.5 C 130.832,143.663 130.498,106.996 129.5,70.5C 125.058,69.0099 120.391,68.0099 115.5,67.5C 115.667,86.8362 115.5,106.17 115,125.5C 114.261,129.75 113.094,133.75 111.5,137.5C 111.89,134.161 112.39,130.827 113,127.5C 113.333,107.167 113.667,86.8333 114,66.5C 119.971,65.45 125.638,66.45 131,69.5C 131.831,106.669 131.664,143.669 130.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4afb9",
    d: "M 136.5,70.5 C 136.168,106.671 136.502,142.671 137.5,178.5C 137.158,179.338 136.492,179.672 135.5,179.5C 135.168,142.996 135.502,106.663 136.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e7e7e7",
    d: "M 173.5,59.5 C 170.036,62.7385 166.036,65.2385 161.5,67C 153.312,69.2537 144.979,70.4204 136.5,70.5C 135.502,106.663 135.168,142.996 135.5,179.5C 134.17,142.998 134.17,106.331 135.5,69.5C 143.422,67.9159 151.422,66.7492 159.5,66C 164.085,63.5308 168.752,61.3641 173.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e4e5e6",
    d: "M 64.5,93.5 C 61.2847,106.658 60.618,119.991 62.5,133.5C 61.0689,133.119 60.2355,132.119 60,130.5C 59.3333,121.167 59.3333,111.833 60,102.5C 60.5257,99.7284 61.3591,97.0618 62.5,94.5C 63.1835,94.1373 63.8501,93.8039 64.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e3e4e4",
    d: "M 47.5,97.5 C 46.1137,104.328 44.1137,110.994 41.5,117.5C 38.245,133.504 39.245,149.17 44.5,164.5C 39.0814,155.708 36.7481,146.041 37.5,135.5C 37.4181,121.822 40.7514,109.156 47.5,97.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0e1e1",
    d: "M 111.5,137.5 C 111.657,138.873 111.49,140.207 111,141.5C 105.645,150.891 98.4783,158.557 89.5,164.5C 89.5394,163.417 89.8728,162.417 90.5,161.5C 95.2128,157.743 99.7128,153.743 104,149.5C 106.788,145.565 109.288,141.565 111.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e2e2e2",
    d: "M 171.5,163.5 C 171.813,160.753 171.48,158.086 170.5,155.5C 169.717,157.288 168.384,158.288 166.5,158.5C 169.503,154.491 172.503,150.491 175.5,146.5C 176.202,152.604 174.869,158.27 171.5,163.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e3e4e5",
    d: "M 166.5,173.5 C 156.521,190.788 141.521,200.454 121.5,202.5C 112.822,202.416 104.155,202.083 95.5,201.5C 84.4055,199.476 74.4055,195.143 65.5,188.5C 73.7044,192.1 82.0377,195.434 90.5,198.5C 98.2947,199.802 106.128,200.802 114,201.5C 135.899,200.979 152.732,191.812 164.5,174C 165.094,173.536 165.761,173.369 166.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bfc4ca",
    d: "M 95.5,201.5 C 104.155,202.083 112.822,202.416 121.5,202.5C 118.351,203.165 115.018,203.498 111.5,203.5C 105.923,203.632 100.59,202.965 95.5,201.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTribunnewsNew);
export default __webpack_public_path__ + "static/media/tribunnews_new.16d13c674ceda0e25c30d9636117b474.svg";
export { ForwardRef as ReactComponent };